export default __webpack_public_path__ + "i18n/translations/translation-sv.f970c2e9.json";